import { gql } from '@apollo/client'

/**
 * gets the string for `getOrders` query
 * returns the session's own order history, newest-first, paginated
 * @internal
 */

/*
 * The items selection stays deliberately narrow rather than pulling the shared
 * `cartProductsFieldsQuery` fragment that `lastOrder` uses. The user API
 * returns parent orders unenriched, so the rest of the `CartProduct` payload
 * resolves to nulls.
 *
 * These five fields are exactly what the screen needs and no more. `sku` and
 * `quantity` are what `prefillCart` sends when a shopper taps Order again
 * (COM-726); `package { name }` carries the packaging they originally chose;
 * `price` and `name` feed the GTM event. Counting the lines gives
 * `itemsCount`, a field `Order` does not carry.
 */
const getOrdersQuery = gql`
  query GetOrders(
    $storefrontName: String!
    $sessionUid: ID!
    $pagination: PaginationInput
    $filter: SessionOrderFilterInput
  ) {
    getOrders(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      pagination: $pagination
      filter: $filter
    ) {
      orders {
        id
        createdAt
        status
        total
        sequence
        items {
          sku
          quantity
          price
          name
          package {
            name
          }
        }
      }
      pagination {
        total
        totalPages
        pageNumber
        pageSize
        hasNextPage
        nextPage
      }
    }
  }
`

export default getOrdersQuery
